module.exports = __webpack_public_path__ + "media/images/font/SofiaPro-Bold-10939bf2343fdaaad0cf32a4ffd86b4e.eot";